import React, { useState, useEffect } from 'react';
import { Message, Transition } from 'semantic-ui-react';

/**
 * Component qui affichage la liste des messages
 * @param {array} props.listMessage 
 */
const PageMessage = (props) => {
  const [listMessageState, setListMessage] = useState([]);

  useEffect(() => {
    if(props.listMessage) {
      setListMessage(props.listMessage);
      // setListMessage([{
      //   info: false,
      //   warning: false,
      //   positive: true,
      //   negative: false,
      //   size: 'large',
      //   icon: 'inbox',
      //   header: 'Have you heard about our mailing list?',
      //   content: 'Get the best news in your e-mail every day.',
      //   transition: true,
      //   visible: true,
      // }]);
    }
  }, [props]);

  /**
   * Retourne la liste des messages
   * @returns array listMessage
   */
  const getListMessage = () => {
    let listMessage = [];
    let key = 0;
    for (let message of listMessageState) {
      let componentMsg = <Message key={key} info={message.info} warning={message.warning} positive={message.positive} negative={message.negative} icon={message.icon} header={message.header} content={message.content} size={message.size} />;

      componentMsg = (message.transition) ? <Transition key={key} visible={message.visible} animation="fade down" duration={500}><div>{componentMsg}</div></Transition> : componentMsg;
      listMessage.push(componentMsg);
      key++;
    }

    return listMessage;
  }

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    (listMessageState && listMessageState.length > 0) ? (
      <div className="mt-5">
        {getListMessage()}
      </div>
    ) : null
  )
};

export default PageMessage;